import { internal, template } from '../../vendor/elix.js';

import TpInput from './tp-input.js';
import FilledFloatingLabelInputMixin from '../mixins/filled-floating-label-input-mixin.js';
import TextFieldIconSlotsMixin from './text-field-icon-slots-mixin.js';
import FormValueMixin from '../mixins/form-value-mixin.js';

class TpTextFieldFilled extends
  TextFieldIconSlotsMixin(
  FilledFloatingLabelInputMixin(
  FormValueMixin(
    TpInput
  ))) {
    
  get [internal.template]() {

    return template.concat(

      super[internal.template],

      template.html`

        <style>

          :host {
            display: inline-block;
          }

          #inner {
            height: 56px;
          }

        </style>
      `
    );

  }
}

export default TpTextFieldFilled;


